import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ClientServiceService } from '../services/client-service.service';
import { Router, ActivatedRoute } from '@angular/router';
// import SignaturePad from "signature_pad";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  activeStep: number = 2;
  auth_client_token: any = null;
  is_dashboard_active: boolean = false;

  is_user_active: boolean = true;
  customer_name: string = "";
  customer_email: string = "";

  dashboard_email: string | null = null;

  isLoaderActive: boolean = true;

  is_livechat_visible: boolean = false;

  constructor (
    private client_service: ClientServiceService,
    private router: Router,
    private active_router: ActivatedRoute
  ) {}


  async ngOnInit(): Promise<void> {
    this.auth_client_token = localStorage.getItem("auth_client_token");
    if (!this.auth_client_token) {
      this.router.navigate(["/login"]);
    }
    const is_form_visible = this.client_service.get_is_form_visible();
    const chat_data = localStorage.getItem("chat");
    if (chat_data === 'yes') {
      this.is_livechat_visible = true;
    }
    if(is_form_visible) {
      this.client_service.existing_form_email = this.dashboard_email as string;
      this.is_dashboard_active = false;
      this.get_customer_detail();
      return
    }
    this.active_router.queryParams.subscribe(params => {
      this.dashboard_email = params['email'] || null;
    });
    await this.get_customer_detail();
    if (!this.is_user_active) {
      this.isLoaderActive = false;
      this.get_customer_forms();
      return;
    }
    if (this.dashboard_email !== null) {
      this.isLoaderActive = false;
      this.is_dashboard_active = true;
      return
    }
    this.get_customer_forms();
  }

  get_customer_detail(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.client_service.get_customer_info(this.auth_client_token).subscribe({
        next: (data) => {
          if (data.status !== "Active") {
            this.is_user_active = false;
          }
          resolve();
        },
        error: (err) => {
          if (err.status === 401) {
            this.router.navigate(["/login"]);
          }
          reject(err);
        }
      });
    });
  }

  get_customer_forms() {
    this.client_service.get_client_forms(this.auth_client_token).subscribe({
      next: (data) => {
        this.client_service.set_client_form_emails(
          data.map((form: any) => form.email)
        )
        if (data.length > 0) {
          this.customer_name = `${data[0].first_name} ${data[0].last_name}`;
          this.customer_email = data[0].email;

          const is_form_visible = this.client_service.get_is_form_visible();

          if (!is_form_visible && this.is_user_active) {
            this.is_dashboard_active = true;
            this.router.navigate(['/dashboard'], { queryParams: { email: data[0].email } });
            this.ngOnInit();
          } else {
            this.is_dashboard_active = false;
          }
        }
        this.isLoaderActive = false;
      },
      error: (err) => {
        if (err.error?.detail === "No forms found") {
          this.is_dashboard_active = false;
          this.isLoaderActive = false;
        }
      }
    })
  }

  onPersonalInfoSubmitted() {
    this.activeStep = 3;
  }

  onSignatureSubmitted() {
    this.activeStep = 4;
  }
}
